import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * 判断是否开启门户（首页）
 * @param {Object} pagePermission - 页面权限对象
 * @returns {boolean} true: 开启门户, false: 关闭门户
 */
export function getIsPortalEnabled(pagePermission) {
    const portalCloseFlag = pagePermission?.['portal:default:close'];
    // 如果有值，说明关闭了门户；没值或 undefined，说明开启了门户
    return !portalCloseFlag;
}

/**
 * Hook: 判断是否开启门户（首页）
 * @returns {Object} { isPortalEnabled: ComputedRef<boolean> }
 */
export function useIsPortalEnabled() {
    const store = useStore();

    const isPortalEnabled = computed(() => {
        return getIsPortalEnabled(store.state.pagePermission);
    });

    return {
        isPortalEnabled,
    };
}
